<!-- File: components/CommandPaletteSentEmails.vue -->
<template>
  <div>
    <CommandDialog v-model:open="isOpen" @update:open="handleOpenChange">
      <DialogTitle class="sr-only">Search Sent Emails</DialogTitle>
      <DialogDescription id="command-dialog-description" class="sr-only">
        Search and navigate through your sent emails
      </DialogDescription>
      <CommandInput placeholder="Search sent emails..." v-model="search" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Sent Emails">
          <CommandItem
            v-for="email in filteredEmails"
            :key="email.id"
            :value="email.subject"
            @select="selectEmail(email)"
          >
            <Mail class="mr-2 h-4 w-4" />
            <span>{{ email.subject }}</span>
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem
} from '@/components/ui/command'
import { DialogTitle, DialogDescription } from '@/components/ui/dialog'
import { Mail } from 'lucide-vue-next'

// The component now expects an "emails" prop
const props = defineProps({
  emails: {
    type: Array,
    required: true
  }
})

// Emit a "close" event when the dialog is closed and a "select" event when an email is selected
const emit = defineEmits(['close', 'select'])

const isOpen = ref(false)
const search = ref('')

// Filter emails based on subject or snippet
const filteredEmails = computed(() => {
  return props.emails.filter(email =>
    email.subject.toLowerCase().includes(search.value.toLowerCase()) ||
    email.snippet.toLowerCase().includes(search.value.toLowerCase())
  )
})

const handleOpenChange = (open) => {
  isOpen.value = open
  if (!open) {
    emit('close')
  }
}

const selectEmail = (email) => {
  emit('select', email)
  isOpen.value = false
  emit('close')
}

// Expose a method to open the command palette from the parent
const openCommandPalette = () => {
  isOpen.value = true
}

defineExpose({
  openCommandPalette
})
</script>
